
const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    productMedia: document.querySelector('[data-productMedia]'),
    zoomBtns: document.querySelectorAll('[data-productZoom]'),
  };
  if(selectors.productMedia != null){
  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  window.productMedia = mediaJSON;
  }
  class TemplateProductJS {
    constructor() {
      /* Mobile zoom UI → full-view (see productImageFullview below). Legacy .zomming zoom removed. */
    }
  }

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();

(function productImageFullview() {
  var fullview = document.getElementById('product-image-fullview');
  if (!fullview) return;
  var fullviewImg = fullview.querySelector('.product-image-fullview__img');
  var inner = fullview.querySelector('.product-image-fullview__inner');

  var targetTranslateY = 0;
  var currentTranslateY = 0;
  var rafId = null;
  var easeFactor = 0.08;

  function setTargetFromMouse(e) {
    if (!fullviewImg || !fullview.classList.contains('is-open')) return;
    var rect = fullview.getBoundingClientRect();
    var mouseY = (e && e.clientY != null) ? e.clientY - rect.top : rect.height / 2;
    var viewportHeight = rect.height;
    var imgHeight = fullviewImg.offsetHeight;
    if (imgHeight <= viewportHeight) {
      targetTranslateY = 0;
      return;
    }
    var maxTranslateY = imgHeight - viewportHeight;
    var t = mouseY / viewportHeight;
    targetTranslateY = -maxTranslateY * t;
  }

  function tick() {
    var diff = targetTranslateY - currentTranslateY;
    if (Math.abs(diff) < 0.25) {
      currentTranslateY = targetTranslateY;
    } else {
      currentTranslateY += diff * easeFactor;
    }
    if (fullviewImg) fullviewImg.style.transform = 'translateY(' + currentTranslateY + 'px)';
    rafId = fullview.classList.contains('is-open') ? requestAnimationFrame(tick) : null;
  }

  function startLoop() {
    if (rafId != null) return;
    rafId = requestAnimationFrame(tick);
  }

  function syncMobileZoomIcons(isOpen) {
    var tray = document.getElementById('product-zoom-trigger');
    if (!tray) return;
    var zoomIn = tray.querySelector('[data-zoom-in]');
    var zoomOut = tray.querySelector('[data-zoom-out]');
    if (!zoomIn || !zoomOut) return;
    if (isOpen) {
      zoomIn.classList.add('d-none');
      zoomOut.classList.remove('d-none');
    } else {
      zoomIn.classList.remove('d-none');
      zoomOut.classList.add('d-none');
    }
  }

  function getActiveGalleryImage() {
    var img = document.querySelector('.pdp-carousel .swiper-slide-active .product-gallery-image');
    if (!img) img = document.querySelector('.product-carousel .swiper-slide-active .product-gallery-image');
    return img;
  }

  function openActiveSlideFullview() {
    var img = getActiveGalleryImage();
    if (!img) return;
    var src = img.getAttribute('data-fullview') || img.currentSrc || img.src;
    if (src) openFullview(src, img.getAttribute('alt') || '');
  }

  function openFullview(src, alt) {
    if (!fullviewImg || !src) return;
    currentTranslateY = 0;
    targetTranslateY = 0;
    fullviewImg.style.transform = 'translateY(0)';
    fullviewImg.src = src;
    fullviewImg.alt = alt || '';
    fullview.classList.add('is-open');
    fullview.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    syncMobileZoomIcons(true);
    fullviewImg.onload = function () {
      var rect = fullview.getBoundingClientRect();
      setTargetFromMouse({ clientY: rect.top + rect.height / 2 });
      currentTranslateY = targetTranslateY;
      fullviewImg.style.transform = 'translateY(' + currentTranslateY + 'px)';
      startLoop();
    };
  }

  function closeFullview() {
    fullview.classList.remove('is-open');
    fullview.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    syncMobileZoomIcons(false);
    if (rafId != null) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
    currentTranslateY = 0;
    targetTranslateY = 0;
    if (fullviewImg) fullviewImg.style.transform = 'translateY(0)';
  }

  fullview.addEventListener('mousemove', function (e) {
    if (e.target === fullview || e.target === inner || e.target === fullviewImg) {
      setTargetFromMouse(e);
      startLoop();
    }
  });

  document.querySelectorAll('.product-gallery-image').forEach(function (img) {
    img.addEventListener('click', function (e) {
      var src = img.getAttribute('data-fullview') || img.currentSrc || img.src;
      if (src) {
        e.preventDefault();
        openFullview(src, img.getAttribute('alt') || '');
      }
    });
  });

  var zoomTrigger = document.getElementById('product-zoom-trigger');
  if (zoomTrigger) {
    zoomTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (fullview.classList.contains('is-open')) {
        closeFullview();
      } else {
        openActiveSlideFullview();
      }
    });
    zoomTrigger.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      if (fullview.classList.contains('is-open')) {
        closeFullview();
      } else {
        openActiveSlideFullview();
      }
    });
  }

  var fullviewCloseBtn = document.getElementById('product-fullview-close');
  if (fullviewCloseBtn) {
    fullviewCloseBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeFullview();
    });
    fullviewCloseBtn.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      e.stopPropagation();
      closeFullview();
    });
  }

  fullview.addEventListener('click', function () {
    if (fullview.classList.contains('is-open')) closeFullview();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && fullview.classList.contains('is-open')) closeFullview();
  });
})();
